import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c0595e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "CommercialBanners",
  class: "carousel-banner carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"carousel-heading w-100 text-white text-lg-end\" data-v-6c0595e6><div class=\"container-lg h-100\" data-v-6c0595e6><div class=\"row h-100 justify-content-center align-items-center\" data-v-6c0595e6><div class=\"col-11 col-md-9\" data-v-6c0595e6><h2 class=\"text-uppercase h1 mb-2 mb-lg-3 fw-bold\" data-v-6c0595e6>More Than Energy</h2><div class=\"banner-copy mb-5\" data-v-6c0595e6><span class=\"h3 fw-normal d-block mb-2\" data-v-6c0595e6>Your partners in renewable energy solutions</span><span class=\"h5 d-block\" style=\"text-transform:none;\" data-v-6c0595e6>Complete sourcing and logistics solutions for renewable energy leaders</span></div><a href=\"#About\" class=\"btn btn-secondary fw-normal\" data-v-6c0595e6> Learn More <span class=\"fa fa-arrow-right ms-3\" data-v-6c0595e6></span></a></div></div></div></div>", 1)
const _hoisted_4 = {
  key: 0,
  class: "carousel-control"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#CommercialBanners\" data-bs-slide=\"prev\" data-v-6c0595e6><small class=\"mx-3\" data-v-6c0595e6><span class=\"fa fa-arrow-left me-3\" data-v-6c0595e6></span> Prev</small></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#CommercialBanners\" data-bs-slide=\"next\" data-v-6c0595e6><small class=\"mx-3\" data-v-6c0595e6>Next <span class=\"fa fa-arrow-right ms-3\" data-v-6c0595e6></span></small></button>", 2)
const _hoisted_7 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "carousel-inner",
      style: _normalizeStyle(`--max-height:${_ctx.bannerHeight}px`)
    }, [
      _createElementVNode("div", {
        class: "carousel-item slide-darken position-relative active",
        style: _normalizeStyle(`--bg-image: url(${require('@/assets/banner/commercial-home-banner-1.jpg')})`)
      }, [
        _createElementVNode("img", {
          src: `${require('@/assets/banner/commercial-home-banner-1.jpg')}`,
          alt: "Magneto Renewable Energy"
        }, null, 8, _hoisted_2),
        _hoisted_3
      ], 4)
    ], 4),
    (_ctx.slideCount > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}